import { Stagger, StaggerItem, Reveal } from "@/components/motion";
import SectionHeader from "@/components/SectionHeader";
import { WHY_CHOOSE } from "@/data/site";

export default function WhyChooseUs() {
  return (
    <section className="relative overflow-hidden bg-dq-ink py-20 lg:py-28" data-testid="why-choose-us">
      <div className="pointer-events-none absolute -right-20 top-0 h-96 w-96 rounded-full bg-dq-orange/20 blur-3xl" aria-hidden="true" />
      <div className="dq-container relative">
        <div className="max-w-2xl">
          <Reveal><p className="label-eyebrow mb-4 text-dq-orange">Why DiziTeQ</p></Reveal>
          <Reveal delay={0.06}>
            <h2 className="font-display text-3xl font-extrabold leading-[1.1] tracking-tighter text-white sm:text-4xl lg:text-[2.75rem]">
              A growth partner you can actually <span className="gradient-text">trust</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-4 text-lg text-white/55">
              We combine premium craft with data-driven marketing to deliver results that move your business forward.
            </p>
          </Reveal>
        </div>

        <Stagger className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {WHY_CHOOSE.map((w) => (
            <StaggerItem key={w.title}>
              <div className="group h-full rounded-3xl border border-white/10 bg-white/[0.04] p-6 transition-[transform,background-color] duration-300 hover:-translate-y-1.5 hover:bg-white/[0.07]"
                data-testid={`why-card-${w.title.toLowerCase().replace(/\s/g, "-")}`}>
                <span className="grid h-11 w-11 place-items-center rounded-2xl bg-dq-orange/15 text-dq-orange transition-transform duration-300 group-hover:scale-110">
                  <w.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-4 font-display text-base font-bold text-white">{w.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-white/50">{w.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
